import React from "react";
import { ActiveStarIcon, DeleteIcon, RestoreIcon, StarIcon } from "../Icons";
import { Tooltip } from "@mui/material";
import { useAuth } from "../../../features/auth/AuthContext";

const SelectAll = ({
  selectedKeys,
  setSelectedKeys,
  handleFav,
  handleRemoveFav,
  handleDelete,
  handleRestore,
  selectableRows = [],
  isPermanentDelete = false,
}) => {
  const allSelectableKeys = selectableRows.map((row) => row.id);

  const isAllSelected =
    allSelectableKeys.length > 0 &&
    allSelectableKeys.every((key) => selectedKeys.includes(key));

  const isDisabled = !selectableRows?.length || selectedKeys.length === 0;

  const baseBtnClass = "bg-transparent border-none transition-opacity";
  const disabledClass = isDisabled
    ? "opacity-40 disabled:cursor-not-allowed"
    : "cursor-pointer";

  const handleSelectAll = () => {
    if (isAllSelected) {
      //  Unselect all
      setSelectedKeys([]);
    } else {
      //  Select ONLY eligible rows
      setSelectedKeys(allSelectableKeys);
    }
  };

  const handleFavClick = () => {
    let payload = { item_type: "file", id_array: selectedKeys };
    if (handleFav) {
      handleFav(payload, setSelectedKeys);
    } else {
      handleRemoveFav(payload, setSelectedKeys);
    }
  };

  const handleRestoreClick = () => {
    handleRestore(selectedKeys, setSelectedKeys);
  };
  const handleDeleteClick = () => {
    handleDelete(selectedKeys);
  };

  return (
    <div className="flex items-center gap-2 pl-[1rem] mt-4">
      <input
        disabled={!allSelectableKeys?.length}
        checked={isAllSelected}
        type="checkbox"
        className="w-[16px] h-[16px] align-middle cursor-pointer disabled:cursor-not-allowed"
        onChange={handleSelectAll}
      />
      <div className="flex items-center gap-0">
        {handleFav && (
          <Tooltip title="Add/Remove from favourites">
            <button
              className={`${baseBtnClass} ${disabledClass}`}
              onClick={!isDisabled ? handleFavClick : undefined}
              disabled={isDisabled}
            >
              <StarIcon w="18" h="18" />
            </button>
          </Tooltip>
        )}
        {handleRemoveFav && (
          <Tooltip title="Remove from favourites">
            <button
              className={`${baseBtnClass} ${disabledClass}`}
              onClick={!isDisabled ? handleFavClick : undefined}
              disabled={isDisabled}
            >
              <ActiveStarIcon w="20" h="20" />
            </button>
          </Tooltip>
        )}
        {handleRestore && (
          <Tooltip title="Restore files">
            <button
              className={`${baseBtnClass} ${disabledClass}`}
              disabled={isDisabled}
              onClick={!isDisabled ? handleRestoreClick : undefined}
            >
              <RestoreIcon w="18" h="18" />
            </button>
          </Tooltip>
        )}
        {handleDelete && (
          <Tooltip title="Delete">
            <button
              className={`${baseBtnClass} ${disabledClass}`}
              disabled={isDisabled}
              onClick={!isDisabled ? handleDeleteClick : undefined}
            >
              <DeleteIcon w="15" h="17" />
            </button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default SelectAll;
